exports = module.exports = require("../../../../../../home/node/site/node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../home/node/site/node_modules/css-loader/index.js?minimize!./css/serp.css"), "");

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/node/site/node_modules/css-loader?minimize!/home/node/site/node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!/home/node/site/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/serp/Serp.vue
// module id = 357
// module chunks = 0